import { render, staticRenderFns } from "./AdminAlert.vue?vue&type=template&id=3db7b3a2&"
import script from "./AdminAlert.vue?vue&type=script&lang=js&"
export * from "./AdminAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports